import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// Components
import SidebarOption from './SidebarOption';
import Logo from '../common/Logo_Round';

// Icons
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const SidebarMobile = ({ 
    slideMenu, 
    handleSlideMenu,
    auth: {
        isAuthenticated
    }
}) => {

    // Which page to display
        const [page_filter, handlePage] = useState(null);
        
    // Set which settings page to display
    useEffect(() => {
        let pathname = window.location.pathname;
        let url_hash = window.location.hash;
        const pathArray = pathname.split('/');
        const settingsPage = pathArray[pathArray.length - 1];

        if(url_hash) {
            handlePage(url_hash);
        } else {
            handlePage(settingsPage);
        }
        
    }, [window.location]);

    let not_Landing_Page = false;
    let isSettingsPage = false;
    
    if(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2] === "settings") {
        not_Landing_Page = true;
        isSettingsPage = true;
    }

    const url_page = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1];
    if(url_page === "checkout" || url_page === "signin" || url_page === "signup" || url_page === "report-issues" || url_page === "policies") {
        not_Landing_Page = true;
    }

    return (      
        <div className={slideMenu ? "nav open": "nav"}>
            <div className="sidebar-mobile" style={{display:'flex', height:'100vh', flexDirection:'column'}}>

                {/* Logo Container */}
                <div onClick={() => window.location = '/'} style={{gap: '.5rem', margin: '1.5rem 0', display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                    {/* Img - Logo */}
                    <img alt="Interview Cheater" loading="lazy" width="20" height="20" decoding="async" src={Logo} style={{borderRadius: '50%', width: '50px', height: '50px'}} />
                </div>

                {/* Button */}
                {isAuthenticated ? (   
                    <a href="/checkout">
                        <button style={{width: '100%', boxShadow: '0 0 20px rgba(255,191,0,.3)', background: '#FFFF00', color:'#000', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', padding: '.5rem 1rem', borderRadius: '14px', cursor: 'pointer'}}>
                            Subscribe
                        </button>
                    </a>
                ) : (
                    <a href="/signin">
                        <button style={{width: '100%', boxShadow: '0 0 20px rgba(255,191,0,.3)', background: '#FFFF00', color:'#000', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', padding: '.5rem 1rem', borderRadius: '14px', cursor: 'pointer'}}>
                            Sign In
                        </button>
                    </a>
                )}

                {/* --- Sidebar options */} 
                {not_Landing_Page ? ( // Use conditional block, because browser complains with the 'toggle={!not_Landing_Page}' solution
                    <SidebarOption active={page_filter === "#proof"} text="Proof" link={not_Landing_Page ? "/#proof" : "#proof"} handleSlideMenu={handleSlideMenu} />
                ) : (
                    <SidebarOption toggle active={false} text="Proof" link={not_Landing_Page ? "/#proof" : "#proof"} handleSlideMenu={handleSlideMenu} />
                )}
                
                <SidebarOption active={page_filter === "help"} text="Help" link="/help" />
                {not_Landing_Page ? ( // Use conditional block, because browser complains with the 'toggle={!not_Landing_Page}' solution
                    <SidebarOption active={page_filter === "#pricing"} text="Pricing" link={not_Landing_Page ? "/#pricing" : "#pricing"} handleSlideMenu={handleSlideMenu} />
                ) : (
                    <SidebarOption toggle active={false} text="Pricing" link={not_Landing_Page ? "/#pricing" : "#pricing"} handleSlideMenu={handleSlideMenu} />
                )}
                
                {isAuthenticated && (
                    <Fragment>
                        <SidebarOption active={isSettingsPage} text="Settings" link="/settings" />
                        <SidebarOption danger text="Logout" link="/search" />
                    </Fragment>
                )}
                
            </div>
            <a href="#" className="close" onClick={handleSlideMenu}>
                <CloseOutlinedIcon />
            </a>
        </div>
    )
}

// Connect the SidebarMobile component to the Redux store and export it
export default SidebarMobile;